<h2 class="margin-bottom-32">Review & Confirm</h2>

<div
  class="completion-box"
  [class.highlight]="true"
  fxLayout
  fxLayoutGap="4px"
  fxLayoutAlign="start start"
  fxLayout.lt-md="column"
  style="margin-bottom: 24px"
  fxLayoutAlign.lt-md="start start">
  <div>
    <p class="nomargin night-darker">
      Name:
      <span>{{ tax.name }}</span>
    </p>

    <p *ngIf="tax.description" class="nomargin night-darker">
      Description:
      <span>{{ tax.description }}</span>
    </p>

    <p *ngIf="tax.tax_identifier" class="nomargin night-darker">
      Tax ID:
      <span>{{ tax.tax_identifier }}</span>
    </p>

    <p class="nomargin night-darker">
      Amount:
      <span *ngIf="tax.charge_type === 'fixed'">
        {{ tax.value }}
        {{ taxService.getFriendlyCalculationTypeLabel(tax.calculation_type) }}
        will be added in the currency of the property.
      </span>
      <span *ngIf="tax.charge_type === 'percent'">
        {{ tax.value }}% of
        <span *ngIf="tax.subjects?.length > 1">the sum of</span>
        the
        <span *ngFor="let subject of tax.subjects; let last = last">
          {{ taxService.getFriendlySubjectLabel(subject).replace('-', ' ') }}
          <span *ngIf="!last">,</span>
        </span>
        will be added.
      </span>
    </p>
  </div>
</div>

<div
  *ngIf="tax.subjects.indexOf('linen-fees') > -1 || tax.subjects.indexOf('cleaning-fees') > -1"
  style="margin-top: 24px; line-height: 1.6"
  fxLayoutGap="8px"
  fxLayoutAlign="start center">
  <svg fxHide.lt-md width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.22779 11H8.75274C8.50076 11 8.2591 10.8946 8.08092 10.7071C7.90274 10.5196 7.80264 10.2652 7.80264 10V7.5C7.80264 7.36739 7.75259 7.24022 7.6635 7.14645C7.57441 7.05268 7.45358 7 7.32759 7H6.85254"
      stroke="#B3AFBB"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M7.56516 4.5C7.51818 4.5 7.47226 4.51466 7.4332 4.54213C7.39414 4.5696 7.36369 4.60865 7.34572 4.65433C7.32774 4.70001 7.32304 4.75028 7.3322 4.79877C7.34137 4.84727 7.36399 4.89181 7.39721 4.92678C7.43042 4.96174 7.47275 4.98555 7.51882 4.9952C7.5649 5.00484 7.61266 4.99989 7.65606 4.98097C7.69946 4.96205 7.73656 4.93 7.76266 4.88889C7.78876 4.84778 7.80269 4.79945 7.80269 4.75C7.80269 4.6837 7.77766 4.62011 7.73312 4.57322C7.68857 4.52634 7.62816 4.5 7.56516 4.5Z"
      stroke="#B3AFBB"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M7.80251 15.5C11.738 15.5 14.9283 12.1421 14.9283 8C14.9283 3.85786 11.738 0.5 7.80251 0.5C3.86706 0.5 0.676758 3.85786 0.676758 8C0.676758 12.1421 3.86706 15.5 7.80251 15.5Z"
      stroke="#B3AFBB"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>

  <span>Linen fees and cleaning fees will be displayed as one item with taxes included during the booking flow.</span>
</div>

<div style="margin-top: 32px" fxLayout fxLayoutGap="24px" fxLayoutAlign="end center">
  <sbnb-button
    data-intercom-target="booking-com-set-markup-skip"
    label="Back"
    type="secondary"
    (click)="back()"></sbnb-button>
  <sbnb-button
    data-intercom-target="direct-com-set-markup-save"
    [loading]="saving"
    [label]="saving ? 'Saving...' : 'Save'"
    (click)="progress()"></sbnb-button>
</div>
